'use client';

import { createContext, useContext } from 'react';

var FormItemContext = createContext({
    rules: [],
    errorMsg: ''
});
function useFormItemContext() {
    return useContext(FormItemContext);
}

export { FormItemContext, useFormItemContext as default };
//# sourceMappingURL=context.js.map
